"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const qcobjects_1 = require("qcobjects");
const showdown_1 = __importDefault(require("showdown"));
(0, qcobjects_1.Package)("org.quickcorp.custom.template.handlers", [
    class MarkdownTemplateHandler extends qcobjects_1.DefaultTemplateHandler {
        assign() {
            const converter = new showdown_1.default.Converter();
            converter.setFlavor("github");
            return converter.makeHtml(this.template).replace(/href="#/g, "href=\"/");
        }
    }
]);
(0, qcobjects_1.Package)("org.quickcorp.custom.template.handlers.markdown", [
    class SideMarkdownTemplateHandler extends (0, qcobjects_1.ClassFactory)("MarkdownTemplateHandler") {
        extractReference(html) {
            const matches = html.match(/<!-- TOC([\s\S]*?)<!-- \/TOC -->/gmi);
            if (matches !== null) {
                const toc = matches[0];
                html = `<details open="">
                <summary>Reference</summary>
                ${toc}
                </details>`.replace(/href="#/g, "href=\"/");
            }
            return html;
        }
        assign() {
            const converter = new showdown_1.default.Converter();
            converter.setFlavor("github");
            const html = converter.makeHtml(this.template);
            return this.extractReference(html);
        }
    }
]);
